module.exports = __webpack_public_path__ + "img/2.04c74868.jpg";